import { Component, Vue } from "vue-property-decorator";

@Component
export default class ErrorHandler extends Vue {
  private isSnackbarVisible = false;
  private errorsQueue = new Array<any>();
  private message = "";

  constructor() {
    super();

    this.$store.watch(
      state => state.error,
      newVal => {
        this.errorsQueue.push(newVal);
        this.processQueue();
      }
    );
  }

  private processQueue() {
    if (this.isSnackbarVisible || this.errorsQueue.length === 0) {
      return;
    }

    const error = this.errorsQueue.shift();
    this.message = this.$t("DefaultErrorMessage").toString()

    this.isSnackbarVisible = true;
  }

  private snackbarVisibilityChanged(isOpening: boolean) {
    if (isOpening) {
      return;
    }

    this.isSnackbarVisible = false;
    setTimeout(this.processQueue, 1000);
  }
}
